import { useQuery } from "@apollo/client/react";

import { HomeFilterInputFilterType } from '../components';
import { HOME_REPORT_SUMMARY } from '../graphql';

interface UseHomeReportSummaryProps {
  filters: HomeFilterInputFilterType;
  skip: boolean;
}

export const useHomeReportSummary = ({ filters, skip }: UseHomeReportSummaryProps) => {
  const { dimensions: _dimension, chartTab: _chartTab, metric: _metric, ...filterInput } = filters;
  const { data, loading, error, refetch } = useQuery(HOME_REPORT_SUMMARY, {
    variables: {
      filter: filterInput,
    },
    skip,
  });

  return {
    reportSummary: data?.saleChannelReportSummary,
    loading,
    error,
    refetch,
  };
};
